import { findKey } from 'lodash';
import {
    AuthenticationFlowName,
    AuthenticationFlowType,
    AUTHENTICATION_FLOW_TYPE_MAP,
} from '../../shared/constants/authenticationFlow';

export const getAuthenticationFlowType = (flowType: AuthenticationFlowName): AuthenticationFlowType | null => {
    const authenticationFlowTypeKey = findKey(AUTHENTICATION_FLOW_TYPE_MAP, ({ name }) => name === flowType);

    if (!authenticationFlowTypeKey) {
        return null;
    }

    return AUTHENTICATION_FLOW_TYPE_MAP[authenticationFlowTypeKey];
};
